import { HTTP } from "@/helpers/http-common";

const url = "/api/combos"

const get = (combo) => new Promise((resolve, reject) => {
  const { option } = combo;
  HTTP.get(`${url}/${option}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const getByParameter = (combo) => new Promise((resolve, reject) => {
  const { option, parameter } = combo;
  HTTP.get(`${url}/parameter`, { params: { option, parameter } }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

const getSeverSide = (combo) => new Promise((resolve, reject) => {
  const { option, keyword } = combo;
  HTTP.get(`${url}/serverSide`, { params: { option, keyword } }
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default {
  get
  , getByParameter
  , getSeverSide
}




// WEBPACK FOOTER //
// ./src/services/catalogos/index.js